<div class="login" fxLayout="column">
	<div fxLayout="row" style="height: 100%;" fxLayoutAlign="center center ">
		<mat-card class="padding-25 mat-elevation-z5" fxFlex="370px"  fxFlex.sm="80%" fxFlex.lt-sm="90%" >
		<form *ngIf="!isLoggedIn && (deconsolidatorList?.length < 1)" [formGroup]="loginForm"  fxLayout="column" (ngSubmit)="loginForm.valid && onSubmit(loginForm.value)"
		autocomplete="off" autocorrect="off" fxLayoutGap="25px"  novalidate>
			
			<!--Image Logo-->
			<img escCustomId="logo" escComponentName="esc_login" class="logo" 
			src="assets/images/escience-banner.png"
			alt="E-Science Logo">

			<!--Statement Logo-->
			<!-- <h2 class="mat-display-1 mat-primary-color">E-Science Corporation</h2> -->

			<mat-label escCustomId="error" class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
				{{errorMessage}}
			</mat-label>

			<mat-form-field escCustomId="username">
				<input  matInput 
					[placeholder]="'USERNAME' | translate"
					formControlName="username" 
					autocomplete="off"
					required
					>
				<mat-error escCustomId="username_required" *ngIf="loginForm.controls['username'].hasError('required')">
					{{ 'MESSAGE_ERROR_USERNAME_REQUIRED' | translate }}
				</mat-error>
				<mat-error escCustomId="username_whitespace" *ngIf="loginForm.controls['username'].hasError('whitespace')">
					{{ 'MESSAGE_ERROR_INVALID_USERNAME' | translate }}
				</mat-error>
			</mat-form-field>

			<mat-form-field>
				<input escCustomId="password" matInput [placeholder]="'PASSWORD' | translate" formControlName="password" [type]="isPasswordShown ? 'text' : 'password'"
				required>
				<mat-icon escCustomId="password" *ngIf="loginForm.controls['password'].value" [svgIcon]="isPasswordShown ? 'eye-off' : 'eye'" (click)="isPasswordShown = !isPasswordShown"
				matSuffix>
				</mat-icon>

				<mat-error escCustomId="password" *ngIf="loginForm.controls['password'].hasError('required')">
					{{ 'MESSAGE_ERROR_PASSWORD_REQUIRED' | translate }}
				</mat-error>
			</mat-form-field>

			<button escCustomId="login" color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">{{ (isSubmitting ? 'LOGGING_IN' :
				'LOGIN') | translate }}</button>

			<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" >
				<!-- <mat-checkbox formControlName="rememberMe" >
					<mat-label>{{ 'REMEMBER_ME' | translate }}</mat-label>
				</mat-checkbox> -->

				<button escCustomId="forgot_password" mat-button routerLink="../forgot-password" [queryParams]="loginForm.controls['username'].valid ? { username: loginForm.controls['username'].value } : {}"
				color="primary" class="mat-primary-color">{{ 'FORGOT_PASSWORD' | translate }}</button>
			</div>

			<!-- <div fxLayout="column" fxLayout.lt-sm="column" fxLayoutAlign="space-around center">

				<mat-label class="mat-body-2 center">{{ 'MESSAGE_DONT_HAVE_ACCOUNT' | translate}}</mat-label>

				<button mat-button routerLink="../register" color="primary" class="mat-body mat-primary-color">{{ 'REGISTER'
					| translate }}</button>
			</div> -->

		</form>

		<esc-landing-page *ngIf="isLoggedIn && deconsolidatorList?.length > 1" [isSubmitting]="isSubmitting" [deconsolidatorList]="deconsolidatorList" [imgUrl]="imgUrl" (onWarehouseSelect)="onWarehouseSelect($event)">

		</esc-landing-page>
		</mat-card>
	</div>
	<esc-footer></esc-footer>
</div>